module.exports = {
  SELECT_ALL_TRAFFIC_OPERATORS: "SELECT_ALL_TRAFFIC_OPERATORS",
  DESELECT_ALL_TRAFFIC_OPERATORS: "DESELECT_ALL_TRAFFIC_OPERATORS",
  TRAFFIC_OPERATORS_CHECKED: "TRAFFIC_OPERATORS_CHECKED",
};
